import { Col } from 'antd'
import styled from 'styled-components'

const StyledHotkeyContainer = styled(Col)`
  display: flex;
  justify-content: space-between;
  padding: 1rem 0;
`

export default StyledHotkeyContainer
